import React from 'react';
const srcPin = require('../../../../assets/pin.png');
const srcPinSel = require('../../../../assets/pin_select.png');

import { getAllStations } from './apiCalls/getAllStations';
import { configMap } from '../../../globalVars/data';
import { pathSel, setData } from '../../project';
import { useData, useRoutes } from '../../..';

type Tprops = {
  pass: {
    keyPlaces: string;
    pathInitMap: string[];
    arrPins: string[];
    arrFuncs: any[];
  };
  args?: any;
};

export const WebMap = (props: Tprops) => {
  const { args } = props;
  const { keyPlaces, arrFuncs } = props.pass;

  // -------- React Hooks
  const currRoute = useRoutes(ct => ct.currRoute);
  const updatedPins = useData(ct => ct.temp.updatedPins) ?? [];

  const [mapLoaded, setMapLoaded] = React.useState(false);
  const [mapReady, setMapReady] = React.useState(false);
  const alreadyRendered = React.useRef(false);

  const mapRef = React.useRef<google.maps.Map | null>(null);
  const markersRef = React.useRef<Record<string, google.maps.Marker>>({});
  const updatedPinsRef = React.useRef(updatedPins);

  const path1 = 'sc.A7.forms.iptsChanges.localAddress.geometry.location';
  const newLocation = useData(ct => pathSel(ct, path1));

  const changes = useData(ct => pathSel(ct, 'sc.A7.forms.iptsChanges'));
  const path2 = 'sc.B5.currData.selectedMapPin';
  const selectedMapPin = useData(ct => pathSel(ct, path2));

  const objInitPoint = React.useMemo(
    () => ({
      center: {
        lat: Number(configMap.center.latitude),
        lng: Number(configMap.center.longitude),
      },
      zoom: configMap.zoom,
      streetViewControl: false,
      mapTypeControl: false,
    }),
    [],
  );

  // Elimina pontos que não tiverem coordenadas válidas
  // Evitar erros por falta de coordenadas
  const filteredArrLocations = updatedPins.filter(i => {
    const lat = i?.localAddress?.geometry?.location?.lat;
    const lng = i?.localAddress?.geometry?.location?.lng;
    return typeof lat === 'number' && typeof lng === 'number';
  });

  // 1. Carregar script do Google Maps
  React.useEffect(() => {
    if (!document.getElementById('mf-map-bk')) {
      const script = document.createElement('script');
      script.defer = true;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${keyPlaces}`;
      script.id = 'mf-map-bk';
      script.onload = () => setMapLoaded(true);
      document.head.appendChild(script);
    } else {
      setMapLoaded(true);
    }
  }, []);

  // 2. Inicializar o mapa
  React.useEffect(() => {
    const ready =
      Number.isFinite(objInitPoint.center.lat) &&
      Number.isFinite(objInitPoint.center.lng) &&
      Number.isFinite(objInitPoint.zoom);

    if (mapLoaded && !mapRef.current && ready) {
      console.log('🚨 Criando novo mapa', currRoute);
      // const mapHtmlEl = document.getElementById('googleMap')!;
      const mapHtmlEl = document.getElementById(`googleMap-${currRoute}`)!;
      console.log('🚨 Criando novo mapa', { mapHtmlEl });
      mapRef.current = new google.maps.Map(mapHtmlEl, objInitPoint);
      console.log('🚨 Criando novo mapa', { mapRef });
      setMapReady(true);
    }
  }, [mapLoaded, objInitPoint]);

  // 3. Renderizar marcadores
  React.useEffect(() => {
    if (!mapReady || !mapRef.current || updatedPins.length === 0) return;
    if (!mapReady || !mapRef.current) return;
    if (alreadyRendered.current) return;

    alreadyRendered.current = true;
    const map = mapRef.current;

    const renderMarkers = async () => {
      console.log('>> Renderizando marcadores...');
      console.log('>> Total pins:', filteredArrLocations.length);

      // Limpa marcadores antigos
      Object.values(markersRef.current).forEach(m => m.setMap(null));
      markersRef.current = {};

      // AQUI PEGA OS DADOS DAS ESTAÇÕES DA API
      // http://200.234.207.52:8000/stations
      let allStations: any = [];
      try {
        allStations = await getAllStations();
      } catch (error) {
        console.error('Erro ao carregar estações:', error);
        allStations = [];
      }
      console.log('BlauBla', { allStations });

      // ------------------------------
      // --- Marcador arrastável (ADM)
      // ------------------------------
      if (newLocation) {
        const newLatLng = new google.maps.LatLng(
          newLocation.lat,
          newLocation.lng,
        );
        map.panTo(newLatLng);

        const marker = new google.maps.Marker({
          position: {
            lat: Number(newLocation.lat),
            lng: Number(newLocation.lng),
          },
          map,
          draggable: true,
          icon: {
            url: srcPin,
            scaledSize: new google.maps.Size(38, 44),
          },
        });

        marker.addListener('dragend', () => {
          const pos = marker.getPosition();
          const lat = pos?.lat();
          const lng = pos?.lng();
          const currZoom = marker.map?.getZoom();

          if (lat && lng) {
            let values = { ...changes, zoom: currZoom };
            values.localAddress.geometry.location = { lat, lng };

            setData({
              path: 'sc.A7.forms.iptsChanges',
              value: values,
            });
          }
        });

        // Armazena o marcador
        markersRef.current['__adm__'] = marker;
      }

      // ---------------------------------
      // ------------- Marcadores fixos
      // ---------------------------------
      filteredArrLocations.forEach(item => {
        const docId = item?.docId;
        const location = item.localAddress.geometry.location;
        const position = {
          lat: Number(location.lat),
          lng: Number(location.lng),
        };

        const currStation = allStations.find(
          i => i.ID === Number(item.apiLocationID),
        );
        const isB5Sc = currRoute === 'b5timerAuto';
        const condStatus = isB5Sc ? 'unlock' : 'lock';

        const allRacks = currStation?.racks ?? [];
        const filteredRacks = allRacks.filter(r => r.status === condStatus);

        const isSupervisionado =
          item.locationType?.toLowerCase() === 'supervisionado';

        let objMarker = {};

        if (isSupervisionado) {
          objMarker = {
            position,
            map,
            icon: {
              url: srcPin,
              scaledSize: new google.maps.Size(28, 34),
              labelOrigin: new google.maps.Point(38, 13),
            },

            label: {
              text: String(item.numBikes ?? '0'),
              color: 'black',
              fontSize: '12px',
              fontWeight: 'bold',
            },
          };
        }

        if (!isSupervisionado) {
          objMarker = {
            position,
            map,
            icon: {
              url: srcPin,
              scaledSize: new google.maps.Size(28, 34),
              labelOrigin: new google.maps.Point(38, 13),
            },
            label: {
              text: String(filteredRacks.length ?? 0),
              color: 'black',
              fontSize: '12px',
              fontWeight: 'bold',
            },
          };
        }

        console.log({ objMarker });

        const marker = new google.maps.Marker(objMarker);

        marker.addListener('click', async () => {
          for (const currFunc of arrFuncs) await currFunc(item, args);
        });

        markersRef.current[docId] = marker;
      });

      console.log(
        '>> Total de marcadores renderizados:',
        Object.keys(markersRef.current).length,
      );
    };

    renderMarkers();
  }, [mapReady, filteredArrLocations, selectedMapPin]);

  // 4. Atualizar referência dos pins
  React.useEffect(() => {
    updatedPinsRef.current = updatedPins;
  }, [updatedPins]);

  // 5. Atualização periódica de labels
  // - Busca dados atualizados de estações (Autônomas)
  // - Compara e atualiza labels somente se houver diferença
  // - Reseta dados relacionados a seleção do marcador
  React.useEffect(() => {
    const interval = setInterval(async () => {
      const isAdm = currRoute === 'a6locations';
      const isSuper = currRoute === 'b5timer';
      const condSkip = isAdm || isSuper;
      if (condSkip) {
        console.log('TRAVA DO SETINTERVAL NO MAPA ADM + SUPERVISIONADO');
        return;
      }

      console.log('⏰ Executando intervalo de atualização de labels');
      const pins = updatedPinsRef.current;
      const allStations = await getAllStations();

      pins.forEach(item => {
        const marker = markersRef.current[item.docId];
        if (!marker) return;

        const isSupervisionado =
          item.locationType?.toLowerCase() === 'supervisionado';

        let numberBikes = '0';
        if (isSupervisionado) {
          numberBikes = String(item.numBikes ?? '0');
        } else {
          const currStation = allStations.find(
            i => i.ID === Number(item.apiLocationID),
          );
          if (!currStation) return;
          const condStatus = currRoute === 'b5timerAuto' ? 'unlock' : 'lock';
          const allRacks = currStation?.racks ?? [];
          console.log({ currRoute });
          console.log({ condStatus });
          console.log({ allRacks });
          const filteredRacks = allRacks.filter(r => r.status === condStatus);
          console.log({ filteredRacks });
          numberBikes = String(filteredRacks.length ?? 0);
        }

        const label = marker.getLabel();

        if (label?.text !== numberBikes) {
          if (!label || label.text !== String(numberBikes ?? '0')) {
            marker.setLabel({
              text: String(numberBikes ?? '0'),
              color: 'black',
              fontSize: '12px',
              fontWeight: 'bold',
            });
          }

          console.log('⏰ Atualizado');
          console.log({
            labelAntes: label?.text,
            labelDepois: String(numberBikes ?? '0'),
          });

          // setData({
          //   path: 'sc.B3A.currData.currLocation.show',
          //   value: '',
          // });
          // setData({
          //   path: 'sc.B3A.currData.currLocation.data',
          //   value: {},
          // });
          setData({
            path: 'sc.B5.currData.selectedMapPin',
            value: {},
          });
          setData({
            path: 'sc.B5.currData.currReturnBikeId',
            value: '',
          });
        }
      });
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  // 6. Atualizar Cor do Marcador Selecionado
  React.useEffect(() => {
    if (!mapReady || !mapRef.current || !selectedMapPin) return;

    Object.entries(markersRef.current).forEach(([docId, marker]) => {
      const isSelected = docId === selectedMapPin.docId;
      const newIcon = {
        url: isSelected ? srcPinSel : srcPin,
        scaledSize: new google.maps.Size(28, 34),
        labelOrigin: new google.maps.Point(38, 13),
      };
      marker.setIcon(newIcon);
    });
  }, [selectedMapPin]);

  // 7. Marcador Arrastável do ADM
  React.useEffect(() => {
    if (!mapReady || !mapRef.current || !newLocation) return;

    const map = mapRef.current;

    // Remove marcador ADM anterior, se existir
    if (markersRef.current['__adm__']) {
      markersRef.current['__adm__'].setMap(null);
    }

    const marker = new google.maps.Marker({
      position: {
        lat: Number(newLocation.lat),
        lng: Number(newLocation.lng),
      },
      map,
      draggable: true,
      icon: {
        url: srcPin,
        scaledSize: new google.maps.Size(38, 44),
      },
    });

    marker.addListener('dragend', () => {
      const pos = marker.getPosition();
      const lat = pos?.lat();
      const lng = pos?.lng();
      const currZoom = marker.map?.getZoom();

      if (lat && lng) {
        let values = { ...changes, zoom: currZoom };
        values.localAddress.geometry.location = { lat, lng };

        setData({
          path: 'sc.A7.forms.iptsChanges',
          value: values,
        });
      }
    });

    markersRef.current['__adm__'] = marker;
  }, [mapReady, newLocation]);

  // Return Node Dom
  const stlMap = { width: '100%', height: '100%' };
  return <div id={`googleMap-${currRoute}`} style={stlMap} />;
};
